import objectEntries from './object-entries/object-entries';
import objectValues from './object-values/object-values';
import sendBeacon from './send-beacon/send-beacon';

const POLYFILLS = [
  objectEntries,
  objectValues,
  sendBeacon,
];

export default {
  install: function() {
    POLYFILLS.forEach((p) => {
      p.setup();
    });
  },
};
